module.exports = "<taxihandgo-field [maxLength]=\"maxLength\" [auto]=\"true\" [value]=\"current\" (valueChange)=\"valueChange.emit(field.value)\" #field>\n  <ng-content></ng-content>\n  <div right>\n    <select *ngIf=\"data\" (change)=\"selectIsChanged(select)\" #select>\n      <option *ngFor=\"let value of data | mapToIterable;\" name=\"select\" [value]=\"value.key\">{{value.value.getCaption()}}</option>\n    </select>\n  </div>\n</taxihandgo-field>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/select/select.component.html
// module id = 499
// module chunks = 1